var map = {
	"./arrow.svg": 7944,
	"./close.svg": 899,
	"./closeMobile.svg": 7448,
	"./exitBtn.svg": 3666,
	"./favicon.svg": 7176,
	"./info.svg": 4262,
	"./instagram.svg": 5180,
	"./logo.svg": 6691,
	"./logoFooter.svg": 8272,
	"./logoHeader.svg": 7725,
	"./mute.svg": 7843,
	"./play.svg": 4846,
	"./rotatePhone.svg": 2121,
	"./scrollDown.svg": 7177,
	"./seeMoreArrow.svg": 7703,
	"./sound.svg": 70,
	"./soundcloud.svg": 2523,
	"./soundcloudHero.svg": 9369,
	"./warning.svg": 4273,
	"svgs/arrow.svg": 7944,
	"svgs/close.svg": 899,
	"svgs/closeMobile.svg": 7448,
	"svgs/exitBtn.svg": 3666,
	"svgs/favicon.svg": 7176,
	"svgs/info.svg": 4262,
	"svgs/instagram.svg": 5180,
	"svgs/logo.svg": 6691,
	"svgs/logoFooter.svg": 8272,
	"svgs/logoHeader.svg": 7725,
	"svgs/mute.svg": 7843,
	"svgs/play.svg": 4846,
	"svgs/rotatePhone.svg": 2121,
	"svgs/scrollDown.svg": 7177,
	"svgs/seeMoreArrow.svg": 7703,
	"svgs/sound.svg": 70,
	"svgs/soundcloud.svg": 2523,
	"svgs/soundcloudHero.svg": 9369,
	"svgs/warning.svg": 4273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6984;